//#region Util Imports

import * as _ from 'underscore'

//#endregion


//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { UserSessionService } from '../../../../services/user-session'
import { LocalizationHelper, TypeHelper } from '../../../../helpers'

import { OpDataTypeInGroup } from '../../../../models/core'
import { Enums } from '../../../../models/common'


//#region Public Types

export const SERVICE_NAME: string = 'ImportGridService'

//#endregion


export class ImportGridService {

    //#region Ctor

    constructor(private userSessionService: UserSessionService) { }

    //#endregion


    //#region Columns

    public getGridColumns(dataTypesInGroup: OpDataTypeInGroup[]): DevExpress.ui.dxDataGridColumn[] {
        return _.map(dataTypesInGroup, (dataTypeInGroup: OpDataTypeInGroup) => {
            const dataField: string = dataTypeInGroup.idDataType.toString()

            let caption: string = TypeHelper.emptyString
            let dataType: string = 'object'

            if (dataTypeInGroup.dataType != null) {
                if (dataTypeInGroup.dataType.idDataTypeClass == Enums.DataTypeClass.Text) {
                    dataType = 'string'
                } else if ((dataTypeInGroup.dataType.idDataTypeClass == Enums.DataTypeClass.Integer || dataTypeInGroup.dataType.idDataTypeClass == Enums.DataTypeClass.Real) && !dataTypeInGroup.dataType.idReferenceType) {
                    dataType = 'number'
                } else if (dataTypeInGroup.dataType.idDataTypeClass == Enums.DataTypeClass.Boolean) {
                    dataType = 'boolean'
                } else if (dataTypeInGroup.dataType.idDataTypeClass == Enums.DataTypeClass.Datetime) {
                    dataType = 'date'
                } else {
                    dataType = 'string'
                }
            }

            if (dataTypeInGroup.dataType != null && dataTypeInGroup.dataType.unit != null && dataTypeInGroup.dataType.unit.toString()) {
                caption = dataTypeInGroup.toString() + "[" + dataTypeInGroup.dataType.unit.toString() + "]"
            } else {
                caption = dataTypeInGroup.toString()
            }

            const dxColumn = <DevExpress.ui.dxDataGridColumn>{
                allowEditing: true,
                caption: caption,
                dataField: dataField,
                dataType: dataType,
                falseText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.False),
                filterOperations: undefined,
                trueText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.True),
                visible: true,
            }

            return dxColumn
        })
    }

    //#endregion
}
